import React from "react";


export default function PageNotFound(){


    return(
        <div>
            <h1 className="text-center mt-5">

            Error 404, Page not found

            </h1>        

        </div>

    );




}